(function ($) {
  $(() => {
    const $bookmarkStatusButton = $('.c-bookmark-status');

    if ($bookmarkStatusButton.attr('data-loggedin') == false) {
      return;
    }

    if ($bookmarkStatusButton.length > 0) {
      // eslint-disable-next-line no-undef
      const bookmarkComponent = new BookmarkComponent(
        $bookmarkStatusButton,
        // eslint-disable-next-line no-undef
        ajax_url,
        'wpfe_post_bookmark_status',
        'wpfe_add_bookmark',
        'wpfe_delete_bookmark',
      );
      bookmarkComponent.init();
    }
  }); // End of DOM Ready
}(jQuery));

(function ($) {
  $(() => {
    bookmarkListeners();
  });

  function bookmarkListeners() {
    $('.wpfe-bookmark-list').on('click', '.js-wpfe-delete-bookmark', deleteWpfeBookmark);
  }

  function deleteWpfeBookmark() {
    if (typeof wpfe_bookmark_delete_url === 'undefined') {
      return;
    }

    const bookmarkId = $(this).parents('.wpfe-bookmark-item').data('bookmark-id');
    if (typeof bookmarkId === 'undefined') {
      return;
    }

    const postId = $(this).parents('.wpfe-bookmark-item').data('post-id');
    if (typeof postId === 'undefined') {
      return;
    }

    $.post(wpfe_bookmark_delete_url, { bookmarkId, postId, withFlash: true }, (result) => {
    }).always(() => {
      location.reload();
    });
  }
}(jQuery));
